import { render, staticRenderFns } from "./04-Summary.vue?vue&type=template&id=3bf4428c&scoped=true&"
import script from "./04-Summary.vue?vue&type=script&lang=js&"
export * from "./04-Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4428c",
  null
  
)

export default component.exports